var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccPublicTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7846",
    "data-name": "Rectangle 7846",
    width: 28,
    height: 28,
    transform: "translate(580 1295)",
    fill: "#c1bbbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7865",
    "data-name": "Rectangle 7865",
    width: 21.369,
    height: 25.848,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transport",
    transform: "translate(-580 -1295)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32388",
    "data-name": "Group 32388",
    transform: "translate(583.315 1296.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32390",
    "data-name": "Group 32390",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34591",
    "data-name": "Path 34591",
    d: "M18.958,0H2.412A2.415,2.415,0,0,0,0,2.412V22.088H2.136V23.5a2.348,2.348,0,1,0,4.7,0V22.088h7.707V23.5a2.348,2.348,0,1,0,4.7,0V22.088h2.136V2.412A2.415,2.415,0,0,0,18.958,0M4.488,19.125A1.565,1.565,0,1,1,6.053,17.56a1.563,1.563,0,0,1-1.565,1.565m12.4,0a1.565,1.565,0,1,1,1.565-1.565,1.563,1.563,0,0,1-1.565,1.565m2.067-6.093H2.421V5.345H18.958Z",
    transform: "translate(0 0)",
    fill: "#b3b6c6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccPublicTransport);
export default __webpack_public_path__ + "static/media/mcc_publicTransport.97f950920491154dc8df33636bc25b2f.svg";
export { ForwardRef as ReactComponent };